export default "__VITE_ASSET__d772dcc4__"